import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import ExclusiveContainer from '../components/ExclusiveContainer'
import GeneralContainer from '../components/GeneralContainer'

export default function N25_10_28() {
  return (
    <NoteContainer date={'28/10/2025'} version="20.16.0">
      <VStack w="full">
        <GeneralContainer>
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>
                  Correção do erro que fazia a plataforma quebrar durante várias chamadas simultâneas
                </TaskTitle>
                <TaskBreadcrumb>Geral</TaskBreadcrumb>
                <TaskDescription>
                  Correção do erro que ocorria marjoritariamente nas solicitações de serviços, porém ocorria com menos
                  frequência em outros fluxos
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </GeneralContainer>

        <ExclusiveContainer category="FEATURE" institutions={['teste', 'treinamento', 'agsus']}>
          <ModuleContainer moduleName="APP_CITIZEN">
            <VStack w="full">
              <CategoryContainer category="ADJUSTMENTS">
                <Box>
                  <TaskTitle>Revisão dos textos do fluxo de geração de holerite</TaskTitle>
                  <TaskBreadcrumb>Perfil colaborador/ Início</TaskBreadcrumb>
                  <TaskDescription>Revisão e correção dos textos da consulta do holerite</TaskDescription>
                </Box>
              </CategoryContainer>
            </VStack>
          </ModuleContainer>
        </ExclusiveContainer>

        <ModuleContainer moduleName="REGULATION">
          <VStack w="full">
            <ExclusiveContainer category="FEATURE" institutions={['teste', 'treinamento', 'agsus']}>
              <CategoryContainer category="FEATURE">
                <Box>
                  <TaskTitle important={true}>Relatório de validações das respostas do CASAI</TaskTitle>
                  <TaskBreadcrumb>Regulação/ Relatórios/ Relatórios CASAI</TaskBreadcrumb>
                  <TaskDescription>Criada visualização das validações da verificação do ASO</TaskDescription>
                </Box>
              </CategoryContainer>
            </ExclusiveContainer>
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Otimização das rotas de listagem das solicitações de serviços</TaskTitle>
                <TaskBreadcrumb>Regulação/ Painel de regulação</TaskBreadcrumb>
                <TaskDescription>
                  Agora é possível ver que as solicitações estão carregando mais rápido.
                </TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>
                  Correção do erro que fazia o formulário de transmissão da solicitação não aparecer
                </TaskTitle>
                <TaskBreadcrumb>Regulação/ Painel de regulação</TaskBreadcrumb>
                <TaskDescription>
                  Corrigido o problema que fazia o formulário de transmissão não aparecer na interface
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
